export default __webpack_public_path__ + "static/media/hacker-secred-card.0e1e4bf7.png";